<template>
  <div class="code-image-edit">
    <image-content
      :styles="part.styles"
      :attrs="partAttrs"
      :ids="ids"
      :codePartNodeIndex="codePartNodeIndex"
      :partsContainerType="partsContainerType"
      @reflectCodeImage="reflectCodeImage($event)"
    />
  </div>
</template>

<script>
import ImageContent from '@/components/Content/Palette/EditPartDesign/Editor/Image/ImageContent'

export default {
  props: [
    'current',
    'codePartNodeIndex',
    'src',
    'imageKey',
    'sectionId',
    'partsContainerId',
    'part',
    'partsContainerType'
  ],
  components: {
    ImageContent,
  },
  computed: {
    ids () {
      return {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.part.id
      }
    },
    partAttrs () {
      if (!this.imageKey || !this.part.attrs) return null
      return this.part.attrs.find(attr => attr['data-image-key'] === this.imageKey)
    }
  },
  methods: {
    reflectCodeImage (attrs) {
      this.$store.commit('updateCodeImage', {
        ...this.ids,
        attrs,
        oldImageKey: this.imageKey, // 変更対象の画像を探すため、変更前の画像キーを渡す
      })
      // HTMLを書き換えるため、親に画像情報を渡す
      const codeImageData = {
        type: 'image',
        nodeIndex: this.codePartNodeIndex
      }
      // ない場合もあるので、受け取った値のみ親に送る
      if (attrs.src) codeImageData.newValue = attrs.src
      // innerHTMLを実行するとエスケープされるので、altテキストはデコードして戻しておく &amp; -> &
      if (attrs.alt) codeImageData.alt = this.$utils.string.sanitizeDecode(attrs.alt)
      if (attrs['data-image-key']) codeImageData.key = attrs['data-image-key']
      this.$emit('change', { ...codeImageData })
    },
  }
}
</script>

<style lang="scss" scoped>
.code-image-edit {
  margin: 20px;
  label {
    display: block;
    margin-bottom: 20px;
  }
}
</style>
